import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IPolicyDocument } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { PolicyService } from '../../policy.service';
import { AlertService } from 'src/app/components/alert/alert.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';

@Component({
  selector: 'app-policy-documents',
  templateUrl: './policy-documents.component.html',
  styleUrl: './policy-documents.component.scss',
})
export class PolicyDocumentsComponent implements OnDestroy {

  @Input() documentsList = [];
  destroy$ = new Subject<void>();

  constructor(
    private _spinnerService: SpinnerService,
    private _policyService: PolicyService,
    private _alertService: AlertService
  ) { }

  downloadDocument(document: IPolicyDocument): void {
    LoggerService.logInfo(this.constructor.name, 'downloadDocument', document);
    if (document) {
      this._spinnerService.show();
      this._policyService.downloadPolicyDocument(this.policyNumber, document?.documentId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: response => {
            const fileContent = CommonUtils.checkAndGet(response, 'fileContent', null);
            if (fileContent) {
              this.manageDownloadedDoc(fileContent, this.isIsvPolicy ? document?.documentId : document?.description, 'application/pdf');
            }
            this._spinnerService.hide();
          },
          error: error => {
            LoggerService.logError(this.constructor.name, 'downloadDocument', error);
            this._alertService.openErrorMessage('Errore in fase di download del documento', 'downloadDocument', error);
            this._spinnerService.hide();
          }
        });
    }
  }

  manageDownloadedDoc(base64Data: string, fileName: string, mimeType: string): void {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    const blob = new Blob(byteArrays, { type: mimeType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  get policyNumber(): string {
    return this._policyService.policyId;
  }

  get showTableDocs(): boolean {
    return this.documentsList && this.documentsList.length > 0;
  }

  get isIsvPolicy(): boolean {
    return CommonUtils.getCompanyCode(this._policyService.companyId) === 'isv';
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
